/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocumentActivityPage } from './InboundDocumentActivityPage';
import {
    InboundDocumentActivityPageFromJSON,
    InboundDocumentActivityPageFromJSONTyped,
    InboundDocumentActivityPageToJSON,
    InboundDocumentActivityPageToJSONTyped,
} from './InboundDocumentActivityPage';

/**
 * 
 * @export
 * @interface FindInboundDocumentActivity200Response
 */
export interface FindInboundDocumentActivity200Response {
    /**
     * 
     */
    data?: InboundDocumentActivityPage;
}

/**
 * Check if a given object implements the FindInboundDocumentActivity200Response interface.
 */
export function instanceOfFindInboundDocumentActivity200Response(value: object): value is FindInboundDocumentActivity200Response {
    return true;
}

export function FindInboundDocumentActivity200ResponseFromJSON(json: any): FindInboundDocumentActivity200Response {
    return FindInboundDocumentActivity200ResponseFromJSONTyped(json, false);
}

export function FindInboundDocumentActivity200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindInboundDocumentActivity200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InboundDocumentActivityPageFromJSON(json['data']),
    };
}

export function FindInboundDocumentActivity200ResponseToJSON(json: any): FindInboundDocumentActivity200Response {
    return FindInboundDocumentActivity200ResponseToJSONTyped(json, false);
}

export function FindInboundDocumentActivity200ResponseToJSONTyped(value?: FindInboundDocumentActivity200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InboundDocumentActivityPageToJSON(value['data']),
    };
}

